import { render, staticRenderFns } from "./hqStuHealthQuestionShow.vue?vue&type=template&id=094a0d88&scoped=true"
import script from "./hqStuHealthQuestionShow.vue?vue&type=script&lang=js"
export * from "./hqStuHealthQuestionShow.vue?vue&type=script&lang=js"
import style0 from "./hqStuHealthQuestionShow.vue?vue&type=style&index=0&id=094a0d88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094a0d88",
  null
  
)

export default component.exports